<template>
	<div class="Legjendamap">
		<div class="depth">
			<div class="w-100 emri">{{ lang.sensor }}</div>
			<div class="icon-group">
				<div class="object">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						width="25px"
						height="25px"
						viewBox="0 0 131.019 116.428"
					>
						<polygon
							fill="#2380C7"
							stroke="#000000"
							stroke-miterlimit="10"
							points="65.398,10 93.098,57.977 120.797,105.953 65.398,105.953
10,105.953 37.699,57.977 "
						/>
					</svg>
					<p>Broadband</p>
				</div>
				<div class="object">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						width="25px"
						height="25px"
						viewBox="0 0 131.019 116.428"
					>
						<polygon
							fill="#f6ff00"
							stroke="#000000"
							stroke-miterlimit="10"
							points="65.398,10 93.098,57.977 120.797,105.953 65.398,105.953
10,105.953 37.699,57.977 "
						/>
					</svg>
					<p>Akselograf</p>
				</div>
				<div class="object">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						width="25px"
						height="25px"
						viewBox="0 0 131.019 116.428"
					>
						<polygon
							fill="#67e30e"
							stroke="#000000"
							stroke-miterlimit="10"
							points="65.398,10 93.098,57.977 120.797,105.953 65.398,105.953
10,105.953 37.699,57.977 "
						/>
					</svg>
					<p>GPS</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'LegjendaMap',
	data() {
		return {};
	},
	computed: {
		lang() {
			return this.$parent.lang;
		}
	}
};
</script>
<style lang="scss" scoped>
.Legjendamap {
	width: 100%;
	display: flex;
	padding: 10px 10px 0;
	justify-content: space-around;
	flex-wrap: wrap;
	@media screen and (max-width: 768px) {
	}
}

.w-100 {
	width: 100%;
}
.icon-group {
	display: flex;
	justify-content: space-between;
	align-items: center;
	svg {
		margin-right: 5px;
		&:last-child {
			margin-right: 0;
		}
	}
}
.emri {
	display: block;
	text-align: center;
	margin-bottom: 10px; /**/
	font-weight: bold;
}

.magnitude {
	/*max-width: 400px;*/
	font-size: 13px;
	/*margin-bottom: 10px;
	margin-right: 5%;*/
}
.depth {
	/*max-width: 400px;*/
	font-size: 13px;
}
.object {
	/*display: inline-flex;*/
	align-items: center;
	text-align: center;
	margin: 0 10px;
	p {
		margin-bottom: 0;
		font-weight: bold;
	}
}
.description {
	font-size: 12px;
	font-style: italic;
	p {
		margin-bottom: 0;
	}
}
</style>
